import { useEffect, useMemo } from 'react'
import { useSetAtom } from 'jotai'
import { customerModelAtom } from 'pages/Customers/atoms/customersAtoms'
import { CustomerModels } from 'pages/Customers/helpers/types'
import { AccountCapabilities } from 'types/capabilities/capabilities'

export const useCustomerModel = (accountCapabilities: AccountCapabilities) => {
  const setCustomerModelAtom = useSetAtom(customerModelAtom)

  const {
    isPrincipleCustomerCompanyCapabilityEnabled,
    isPrincipleCustomerIndividualCapabilityEnabled,
    isEmbeddedCustomerCompanyCapabilityEnabled,
    isEmbeddedCustomerIndividualCapabilityEnabled,
  } = accountCapabilities || {}

  const isPrincipleCustomerEnabled = useMemo(
    () =>
      isPrincipleCustomerCompanyCapabilityEnabled || isPrincipleCustomerIndividualCapabilityEnabled,
    [isPrincipleCustomerCompanyCapabilityEnabled, isPrincipleCustomerIndividualCapabilityEnabled]
  )

  const isEmbeddedCustomerEnabled = useMemo(
    () =>
      isEmbeddedCustomerCompanyCapabilityEnabled || isEmbeddedCustomerIndividualCapabilityEnabled,
    [isEmbeddedCustomerCompanyCapabilityEnabled, isEmbeddedCustomerIndividualCapabilityEnabled]
  )

  const isCustomersEnabled = useMemo(
    () => isPrincipleCustomerEnabled || isEmbeddedCustomerEnabled,
    [isPrincipleCustomerEnabled, isEmbeddedCustomerEnabled]
  )

  const getCustomerModel = () => {
    if (isEmbeddedCustomerEnabled) return CustomerModels.EMBEDDED
    if (isPrincipleCustomerEnabled) return CustomerModels.NESTED
  }

  useEffect(() => {
    setCustomerModelAtom(getCustomerModel())
  }, [isPrincipleCustomerEnabled, isEmbeddedCustomerEnabled])

  return { isCustomersEnabled }
}
